import { render } from 'preact';
import { MetadataCard } from '../metadata/MetadataCard';
import { hasVisibleExifData, buildVisibleExifList } from '../metadata/exifFields';

import { state } from './context';
import { caption_source } from '../settings';

import i18n from '@i18n';

export const initCaption = (lightbox, infos_to_display, animation, animation_duration) => {
  lightbox.on('uiRegister', () => {

    lightbox.pswp.ui.registerElement({
      name: 'custom-caption mwl__metadata' ,
      ariaLabel: i18n.TOOLBAR.IMAGE_CAPTION_AND_METADATA,
      order: 9,
      isButton: false,
      appendTo: 'wrapper',
      html: '',
      onInit: (el, pswp) => {

        // Add aria label for accessibility
        el.setAttribute('aria-label', i18n.TOOLBAR.IMAGE_CAPTION_AND_METADATA);

        // Prevent PhotoSwipe drag/pan when interacting with metadata card
        const preventDrag = (e) => {
          e.stopPropagation();
        };
        
        el.addEventListener('pointerdown', preventDrag);
        el.addEventListener('touchstart', preventDrag);
        el.addEventListener('mousedown', preventDrag);

        lightbox.pswp.on('closingAnimationStart', () => {
           el.style.opacity = 0;
          state.isClosing = true;
        });

        lightbox.pswp.on('closingAnimationEnd', () => {
          state.isClosing = false;
        });

        lightbox.pswp.on('zoomPanUpdate', (e) => {

          const  showOrHideCaption = () => {

            if (e.slide === pswp.currSlide) {

              //We store all the combinsations of lightbox and browser zoom to a default zoom level so we can compare to when the image actually zoomed in to hide the caption

              const zoom = Math.round(pswp.currSlide.currZoomLevel * 100);
              const browserWidth = document.documentElement.clientWidth;
              const dynamicIndex = 'index_' + pswp.currSlide.index + '_' + browserWidth;

              const defaultZoomLevel = state.defaultZoomLevel[dynamicIndex] || 0;

              if ( !defaultZoomLevel ) {
                state.defaultZoomLevel[dynamicIndex] = zoom;
              } else if ( zoom > defaultZoomLevel ) {
                el.style.opacity = 0;
              } else {
                // Only set opacity to 1 if not collapsed (let CSS handle collapsed state)
                if (!el.classList.contains('collapsed')) {
                  el.style.opacity = 1;
                }
              }
            }
          };

          if ( animation !== 'none' && !state.isClosing ) {
            setTimeout(() => {
              showOrHideCaption();
            }, animation_duration);
          } else {
            showOrHideCaption();
          }

        });

        lightbox.pswp.on('change', () => {
          const image = lightbox.pswp.currSlide.data;
          const exifData = buildVisibleExifList(image, infos_to_display);

          const caption_text = image.caption || (image.meta && image.meta.caption);
          const description_text = image.description || (image.meta && image.meta.description);
          const caption = caption_source === 'description' ? description_text : caption_text;
          image.caption = caption;

          const title = (image.exifs && image.exifs.title) || (image.meta && image.meta.title);

          const shouldDisplayTitleOrCaption =
            (infos_to_display.title && title) ||
            (infos_to_display.caption && caption);

          if ((exifData.length === 0 && !shouldDisplayTitleOrCaption) || state.isMapView) {
            el.style.display = 'none';
            return;
          } else {
            el.style.display = '';
          }

          const handleCollapsedChange = (isCollapsed) => {
            el.classList.toggle('collapsed', isCollapsed);
            // Clear inline opacity style so CSS can control it for collapsed state
            if (isCollapsed) {
              el.style.opacity = '';
            }
          };
          
          const captionHTML = <MetadataCard image={image} onCloseClick={() => {}} onCollapsedChange={handleCollapsedChange} />;

          render(captionHTML, el);
        });
      },
    });
  });
};